import { observer } from 'mobx-react-lite';
import LayerLabelItemList from './LayerLabelItemList';
import type { LayerLabelItemListProps, LayerLabelItemListValueProps } from './types';

export type { LayerLabelItemListProps, LayerLabelItemListValueProps };
export default observer(LayerLabelItemList); // MANUAL OVERRIDE
